module.exports = __webpack_public_path__ + "static/media/coins.ea77cf7b.svg";